import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive";
import "datatables.net-responsive-bs4";
import "select2";

$(document).ready(function () {
  $("#data-table").DataTable();
  $(".data-table").DataTable();
  $("select").select2({
    width: '100%',
    alowClear: true,
    placeholder: 'Please select'
  });
});
